// frontend/src/i18n/index.js
import { createI18n } from 'vue-i18n';

// Import locale messages
import en from './locales/en.json';
import de from './locales/de.json';
import sl from './locales/sl.json';
import it from './locales/it.json';
import fr from './locales/fr.json';

const messages = {
  en,
  de,
  sl,
  it,
  fr
};

// Create i18n instance
const i18n = createI18n({
  legacy: false, // Use Composition API
  locale: localStorage.getItem('language') || 'en', // Get language from localStorage or default to English
  fallbackLocale: 'en',
  messages,
  globalInjection: true // Make $t available everywhere
});

export default i18n;